import dayjs from "dayjs";

import { FeatureTime } from "graphql/type.ts";

/**
 * string4文字の0000 を 00:00 に変換する関数
 * @param input string
 * @returns
 */
export const convertTimeFormat = (input: string): string => {
  if (typeof input === "string" && input.length === 4) {
    const hours = input.substring(0, 2);
    const minutes = input.substring(2);
    return `${hours}:${minutes}`;
  }
  return "";
};

/**
 * '00:00' から15分おきに '24:00'までのラベルと値のペアを配列で返す関数
 * @returns [ { label: '00:00', value: '0000' }, ..., { label: '23:45', value: '2345' } ]
 */
export const createTimeOptions = (): { label: string; value: string; disabled: boolean }[] => {
  const timeArray: { label: string; value: string; disabled: boolean }[] = [];
  for (let hours = 0; hours < 24; hours++) {
    for (let minutes = 0; minutes < 60; minutes += 15) {
      const hourString = hours.toString().padStart(2, "0");
      const minuteString = minutes.toString().padStart(2, "0");
      timeArray.push({
        label: `${hourString}:${minuteString}`,
        value: `${hourString}${minuteString}`,
        disabled: false,
      });
    }
  }
  return timeArray;
};

/**
 * 利用可能時間を計算しx時間y分の形式で返す
 * @example
 * calculateAvailableTime(undefined)
 * => "24時間"
 * calculateAvailableTime({ startDate: "", endDate: "" })
 * => "24時間"
 * calculateAvailableTime({ startDate: "00:00", endDate: "23:59" })
 * => "00:00 ~ 23:59"
 */
export const calculateAvailableTime = (time?: FeatureTime): string => {
  if (time == null || (time.startDate === "" && time.endDate === "")) {
    return "24時間";
  }

  const { startDate, endDate } = time;
  return `${startDate} ~ ${endDate}`;
};

export const getTimeStamp = (): string => dayjs().valueOf().toString();

/**
 * 利用開始日付と利用終了日付を比べて、利用開始日付が利用終了日付よりも前かどうかを判定する
 * @param startDate 利用開始日付 例)2001-01-01
 * @param endDate 利用終了日付   例)2001-01-10
 * @returns 利用開始日付が利用終了日付よりも前の場合はtrue、そうでない場合はfalse
 */
export const isStartDateBeforeEndDate = (startDate: string, endDate: string): boolean => {
  return dayjs(startDate).isBefore(dayjs(endDate));
};

/**
 * 利用開始日付と利用終了日付を比べて、利用開始日付が利用終了日付よりも前か同じかどうかを判定する
 * @param startDate 利用開始日付 例)2001-01-01
 * @param endDate 利用終了日付   例)2001-01-10
 * @returns 利用開始日付が利用終了日付よりも前か同じの場合はtrue、そうでない場合はfalse
 */
export const isStartDateBeforeOrSameEndDate = (startDate: string, endDate: string | null): boolean => {
  return dayjs(startDate).isBefore(dayjs(endDate)) || dayjs(startDate).isSame(dayjs(endDate));
};
